import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiHiddenFacilities';
const DEFAULT_VALUE: number[] = [];

const parseHiddenFacilities = (raw: string): number[] => {
	const parsedValue = JSON.parse(raw);
	if (!Array.isArray(parsedValue)) {
		return DEFAULT_VALUE;
	}

	return parsedValue.filter((facilityId): facilityId is number => typeof facilityId === 'number');
};

export const useHiddenFacilities = () => {
	const [hiddenFacilities, setHiddenFacilities] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE, parseHiddenFacilities);
	return { hiddenFacilities, setHiddenFacilities };
};
